import { useAnalytics } from '@/hooks/useAnalytics';
import { useNavigate } from 'react-router-dom';
import { GenericTrackTypes } from '@/types/genericTrackTypes';
import styles from './FlyerCategoryList.styles';
import FlyerCategoryCard from '../FlyerCategoryCard/FlyerCategoryCard';
import { FlyerCategory } from '@/types/flyer';
import { useCategories } from '@/hooks';
import { FlyerType } from '@/config/constants';
import { FadeInWrapper } from '@/components';
import { EventDetails, TrackingEvents, TrackingStage } from '@/config/tracking';
import { useNavigateWithTracking } from '@/hooks';

interface FlyerCategoryListProps {
  type: string;
}

const FlyerCategoryList: React.FC<FlyerCategoryListProps> = ({ type }) => {
  const { track } = useAnalytics();
  const navigateWithTracking = useNavigateWithTracking();
  const { getCategoriesByType } = useCategories();
  const categories = getCategoriesByType(type === FlyerType.school ? FlyerType.school : FlyerType.community);

  const onClick = ({ title, id }: FlyerCategory) => {
    track({
      action: GenericTrackTypes.BUTTON_PRESSED,
      category: `explore_page:category_name`,
      label: title,
    });

    navigateWithTracking(`/explore/all?categoryId=${id}&categoryName=${title}&tab=${type}`, {
      event_from: TrackingEvents.browseContent,
      event_detail_from: EventDetails.browseContent(type),
      stage_from: TrackingStage.discovery,
    });
  };

  return (
    <FadeInWrapper className={styles.container} data-testid="flyerCategories">
      <div className={styles.categories}>
        {categories.map(category => (
          <FlyerCategoryCard category={category} key={category.id} onClick={onClick} />
        ))}
      </div>
    </FadeInWrapper>
  );
};

export default FlyerCategoryList;
